class Paginatable {
	constructor(selector, items_per_page = 9) {
		this.selector = selector;
		this.$elements = this.getVisibleElements();
		this.items_per_page = items_per_page;
		this.page_n = 1;
		this.hideAllElements()
		this.showPaginatedElements()
		this.createButton();
	}

	resetPagination() {
		this.page_n = 1;
		this.$elements = this.getVisibleElements();
		this.hideAllElements();
		this.showPaginatedElements();
		this.$button.hide()
		this.createButton();
	}

	getVisibleElements() {
		return jQuery(this.selector + ':visible');
	}

	hideAllElements() {
		this.$elements.hide();
	}

	showPaginatedElements() {
		this.$elements.slice(0, this.items_per_page * this.page_n).show()
	}

	allElementsVisible() {
		return this.items_per_page * this.page_n >= this.$elements.length
	}

	createButton() {
		if(!this.allElementsVisible() && !this.button) {
			parent_element = jQuery(this.$elements[0].parentElement);
			button_html = '<div class="cell grid-x flex-center-container padding-top-medium"><button class="cell small-6 large-4 ghost-btn-yellow"><span>See More</span></button></div>';
			this.$button = jQuery(button_html).appendTo(parent_element);
			this.$button.on('click', this.buttonClickHandler.bind(this))
		} else if (this.button && !this.allElementsVisible()) {
			this.button.show()
		}
	}

	buttonClickHandler() {
		this.page_n += 1;
		this.showPaginatedElements();
		if (this.allElementsVisible()) {
			this.$button.hide();
		}
	}

}
